import {Component, Input, OnInit} from '@angular/core';
import features from './optimization-features.json';
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

interface IFeature {
  title: string;
  desc: string;
  img: any;
}

@Component({
    selector: 'db-optimization-hosting',
    templateUrl: './optimization-with-hosting.component.html',
    styleUrls: ['./optimization-with-hosting.component.scss'],
    standalone: false
})
export class OptimizationWithHostingComponent implements OnInit {

  public features: IFeature[] = features;
  public showDesc: number;

  @Input() websiteId: number;

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit() {
    this.toggleArrow(0);
  }
  public toggleArrow(index): void {
    if (this.showDesc === index) return;
    this.showDesc === index ? this.showDesc = -1 : this.showDesc = index;
  }
}
